<template>
  <customer-template :type="2"/>
</template>

<script>
import CustomerTemplate from '@/views/basedata/customer_basedata/CustomerTemplate.vue'

export default {
  name: 'CustomerBaseData',
  components: { CustomerTemplate }
}
</script>